import * as React from "react";

// components
import SpinnerComponent from "common/components/spinner";
import SolidReasonInput from "common/components/solidReasonInput";
import SolidButton from "common/components/solidButton";
import { IntlShape } from "react-intl";

const styles = require("./resetPageComponent.scss");

interface IResetPasswordProps {
  resetPassword: Vingle.IResetPasswordState;
  intl: IntlShape;
  onEmailChange: (email: string) => void;
  onSendEmail: React.FormEventHandler<HTMLFormElement>;
}

class ResetPassword extends React.PureComponent<IResetPasswordProps> {
  public render() {
    const { resetPassword, intl, onSendEmail } = this.props;

    let loadingSpinner: React.ReactNode | string = intl.formatMessage({
      id: "reset_password.button_text",
    });
    if (resetPassword.meta.isLoading) {
      loadingSpinner = <SpinnerComponent />;
    }

    return (
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.title}>
            {intl.formatMessage({ id: "reset_password.title" })}
          </div>
          <div className={styles.subTitle}>
            {intl.formatMessage({ id: "reset_password.subTitle" })}
          </div>
        </div>
        <form className={styles.content} onSubmit={onSendEmail}>
          <SolidReasonInput
            value={resetPassword.data.email}
            inputType="email"
            onChange={this.handleEmailChange}
            placeholder={intl.formatMessage({
              id: "reset_password.email_placeholder",
            })}
            isDebounce={false}
            autoFocus={true}
          />
          <SolidButton
            buttonText={loadingSpinner}
            disabled={
              resetPassword.meta.isLoading ||
              !(resetPassword.data.email.length > 0)
            }
            className={styles.sendBtn}
            buttonStyle={{
              backgroundColor: "rgba(0,0,0,0)",
            }}
          />
        </form>
      </div>
    );
  }

  private readonly handleEmailChange: React.ChangeEventHandler<
    HTMLInputElement
  > = e => {
    this.props.onEmailChange(e.currentTarget.value);
  };
}

export default ResetPassword;
